<template>
   <FormSubmitPopup
    v-model="value"
    :title="$t('stowHistory')"
    @popupClose="$emit('input', false)"
    hideRgtBtn
    medium
  >
  <template v-slot:input>
    <v-container>
    <PaginationController
      v-model="items"
      getDataActionName="getStowHistory"
      :historyLimit="25"
      :searchBoxLabel="$t('searchBy UPC/Operator/Inbound time')"
      haveSearchBox
      showSearchBoxLabel
      haveStartDate
    >
    <template v-slot:dataTable>
      <v-data-table
          :headers="headers"
          :items="items"
          item-key="_key"
          class="elevation-2 myDense"
        >
          <template v-slot:items="{item}">
            <td>{{item.dateKeyStr}}</td>
            <td class="text-xs-left">{{ getDateString( item.createTime ) }}</td>
            <td>{{item.operator}}</td>
            <td>{{getSiteName(item.siteKey)}}</td>
            <td class="text-xs-left">
              <div :key="detail.upc" v-for="detail of item.stowList">
                <v-layout>
                  <v-flex md4>{{`${$t('upc')}: ${detail.upc}`}}</v-flex>
                  <v-flex md4>{{`${$t('stowQty')}: ${detail.stowQty}`}}</v-flex>
                  <v-flex md4>{{`${$t('unstowedQty')}: ${detail.unstowedQty}`}}</v-flex>
                </v-layout>
              </div>
            </td>
          </template>
         </v-data-table>
      </template>
    </PaginationController>
    </v-container>
  </template>
  </FormSubmitPopup>

</template>

<script>
import PaginationController from './PaginationController'
import {toTimestampString} from '@/utils/tools'
import FormSubmitPopup from './FormSubmitPopup'

export default {
  name: 'StowHistoryPopup',
  components: {
    PaginationController,
    FormSubmitPopup
  },
  props: {
    value: Boolean
  },
  data () {
    return {
      items: [],
      headers: [
        { text: this.$t('inboundTime'), value: 'inboundTime', align: 'left', sortable: false, width: '12%' },
        { text: this.$t('stowTime'), value: 'stowTime', align: 'left', sortable: false, width: '20%' },
        { text: this.$t('operator'), value: 'operator', align: 'left', sortable: false },
        { text: this.$t('site'), value: 'upc', align: 'left', sortable: true },
        { text: this.$t('detail'), value: 'quantity', align: 'center', sortable: false, width: '40%' }
      ]
    }
  },
  computed: {
    warehouseSites () {
      return this.$store.getters.warehousesSites
    }
  },
  methods: {
    getSiteName (siteKey) {
      if (!siteKey) return ''
      return (this.warehouseSites.find(site => site.key === siteKey) || {siteName: '', key: ''}).siteName
    },
    getDateString (theDate) {
      return toTimestampString(theDate)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/StowHistoryPopup.vue